/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Next_MarkerInputs */

const en_shortcut_keys_name_next_marker = /** @type {(inputs: Shortcut_Keys_Name_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Marker`)
};

const fr_shortcut_keys_name_next_marker = /** @type {(inputs: Shortcut_Keys_Name_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marqueur suivant`)
};

const de_shortcut_keys_name_next_marker = /** @type {(inputs: Shortcut_Keys_Name_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächster Marker`)
};

const it_shortcut_keys_name_next_marker = /** @type {(inputs: Shortcut_Keys_Name_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcatore successivo`)
};

const ru_shortcut_keys_name_next_marker = /** @type {(inputs: Shortcut_Keys_Name_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий маркер`)
};

const es_shortcut_keys_name_next_marker = /** @type {(inputs: Shortcut_Keys_Name_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente marcador`)
};

const zh_cn2_shortcut_keys_name_next_marker = /** @type {(inputs: Shortcut_Keys_Name_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个标记`)
};

const ja_shortcut_keys_name_next_marker = /** @type {(inputs: Shortcut_Keys_Name_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のマーカー`)
};

const hi_shortcut_keys_name_next_marker = /** @type {(inputs: Shortcut_Keys_Name_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला मार्कर`)
};

const pt_pt2_shortcut_keys_name_next_marker = /** @type {(inputs: Shortcut_Keys_Name_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo marcador`)
};

/**
* | output |
* | --- |
* | "Next Marker" |
*
* @param {Shortcut_Keys_Name_Next_MarkerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_next_marker = /** @type {((inputs?: Shortcut_Keys_Name_Next_MarkerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Next_MarkerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_next_marker(inputs)
	if (locale === "de") return de_shortcut_keys_name_next_marker(inputs)
	if (locale === "it") return it_shortcut_keys_name_next_marker(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_next_marker(inputs)
	if (locale === "es") return es_shortcut_keys_name_next_marker(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_next_marker(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_next_marker(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_next_marker(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_next_marker(inputs)
	return en_shortcut_keys_name_next_marker(inputs)
});